(function () {
  function parsePrice(value) {
    const text = String(value ?? '').trim();
    if (!/^\d{1,5}(\.\d{1,2})?$/.test(text)) return null;
    return Math.round(Number(text) * 100);
  }
  function mappingIssue(data, index, scheduleKey) {
    const schedule = data.schedules[scheduleKey];
    const flavour = data.flavours[index];
    if (!data.boxConfirmed) return 'Confirm that each mapped variant unit is one box.';
    if (data.currency !== 'GBP') return 'This builder requires GBP pricing.';
    if (!schedule || !schedule.confirmed) return 'Confirm the selling plan billing/delivery intervals against the dropdown label.';
    if (!/^[1-9]\d*$/.test(String(schedule.plan || ''))) return 'Enter the actual selling-plan ID for this dropdown option.';
    const price = parsePrice(schedule.price);
    if (price === null) return 'Enter the confirmed bundle price per box for this dropdown option.';
    const id = flavour?.[scheduleKey] || flavour?.base;
    const variant = flavour?.variants.find((item) => item.id === String(id));
    if (!variant) return 'Select a flavour product and its existing one-box variant.';
    const allocation = variant.allocations.find((item) => item.id === String(schedule.plan));
    if (!allocation) return 'The selling plan is not attached to this variant.';
    if (allocation.price !== price || allocation.charge !== price) return 'The allocation price/checkout charge does not match the configured bundle price.';
    if (allocation.renewalPrices?.some((renewal) => renewal !== price)) return 'The selling plan changes its price on renewal.';
    if (!variant.available) return 'This flavour is currently sold out.';
    return '';
  }
  function cartItems(data, selections, scheduleKey) {
    if (!Number.isInteger(data.target) || data.target < 1 || selections.length !== data.target || selections.some((index) => !Number.isInteger(index) || mappingIssue(data, index, scheduleKey))) return null;
    const counts = new Map();
    selections.forEach((index) => counts.set(index, (counts.get(index) || 0) + 1));
    return [...counts].map(([index, quantity]) => {
      const flavour = data.flavours[index];
      return {
        id: String(flavour[scheduleKey] || flavour.base),
        quantity,
        selling_plan: String(data.schedules[scheduleKey].plan),
        properties: { Flavour: flavour.title, 'Box allowance': String(data.target), 'Delivery preference': data.schedules[scheduleKey].label, 'Bundle builder': 'Mix and match' }
      };
    });
  }
  if (typeof module !== 'undefined') module.exports = { parsePrice, mappingIssue, cartItems };
  if (typeof document === 'undefined') return;
  if (window.chhabraReferenceBuilder) { window.chhabraReferenceBuilder.initialize(); return; }
  const instances = new WeakMap();
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-reference-builder]').forEach((section) => {
      if (instances.has(section)) return;
      const data = JSON.parse(section.querySelector('[data-builder-data]').textContent);
      const cards = [...section.querySelectorAll('[data-builder-card]')];
      const slots = [...section.querySelectorAll('[data-builder-slot]')];
      const select = section.querySelector('[data-builder-schedule]');
      const checkout = section.querySelector('[data-builder-checkout]');
      const status = section.querySelector('[data-builder-status]');
      const editor = section.querySelector('[data-builder-editor]');
      const error = section.querySelector('[data-builder-error]');
      const selections = [];
      let busy = false;
      const money = (cents) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
      function update() {
        const scheduleKey = select.value;
        const schedule = data.schedules[scheduleKey];
        const price = parsePrice(schedule?.price);
        const items = cartItems(data, selections, scheduleKey);
        section.querySelector('[data-builder-count]').textContent = selections.length;
        section.querySelector('[data-builder-total]').textContent = selections.length === 0 ? money(0) : price === null ? data.labels.pendingPrice : money(price * selections.length);
        cards.forEach((card, index) => {
          const quantity = selections.filter((selected) => selected === index).length;
          card.querySelector('[data-builder-quantity]').textContent = quantity ? ' (' + quantity + ')' : '';
          card.querySelector('[data-builder-add]').disabled = busy || selections.length >= data.target;
        });
        slots.forEach((slot, position) => {
          const index = selections[position];
          const filled = index !== undefined;
          const image = slot.querySelector('[data-builder-slot-image]');
          const remove = slot.querySelector('[data-builder-remove]');
          const source = filled ? cards[index].querySelector('img') : null;
          image.hidden = !source;
          if (source) { image.src = source.currentSrc || source.src; image.alt = data.flavours[index].title; }
          else { image.removeAttribute('src'); image.alt = ''; }
          slot.querySelector('.reference-builder__cube').hidden = !!source;
          slot.classList.toggle('is-filled', filled);
          remove.hidden = !filled;
          remove.disabled = busy;
          remove.setAttribute('aria-label', filled ? 'Remove one ' + data.flavours[index].title + ' box' : 'Remove box ' + (position + 1));
          const caption = slot.parentElement.querySelector('[data-builder-slot-label]');
          if (!caption.dataset.emptyLabel) caption.dataset.emptyLabel = caption.textContent;
          caption.textContent = filled ? data.flavours[index].title : caption.dataset.emptyLabel;
        });
        select.disabled = busy;
        checkout.disabled = busy || !items;
        const remaining = data.target - selections.length;
        let selectLabel = data.labels.select.replace('[count]', remaining);
        if (remaining === 1) selectLabel = selectLabel.replace('BOXES', 'BOX').replace('boxes', 'box');
        checkout.textContent = busy ? 'Adding...' : remaining > 0 ? selectLabel : items ? data.labels.checkout : data.labels.unavailable;
        const issues = cards.map((_, index) => {
          const issue = mappingIssue(data, index, scheduleKey);
          return issue ? data.flavours[index].title + ': ' + issue : '';
        }).filter(Boolean);
        if (!cards.length) issues.push('Add at least one Bundle flavour block.');
        const selectedIssue = selections.some((index) => mappingIssue(data, index, scheduleKey));
        const configured = cards.some((_, index) => !mappingIssue(data, index, scheduleKey));
        status.textContent = selectedIssue || !configured ? data.labels.unavailable : '';
        editor.hidden = !window.Shopify?.designMode || !issues.length;
        editor.textContent = issues.join(' ');
      }
      section.addEventListener('click', (event) => {
        if (busy) return;
        const add = event.target.closest('[data-builder-add]');
        const remove = event.target.closest('[data-builder-remove]');
        if (add && section.contains(add)) {
          const index = Number(add.dataset.builderAdd);
          if (cards[index] && selections.length < data.target) selections.push(index);
        } else if (remove && section.contains(remove)) {
          const position = Number(remove.dataset.builderRemove);
          if (position >= 0 && position < selections.length) selections.splice(position, 1);
        } else return;
        error.hidden = true;
        update();
      });
      select.addEventListener('change', () => { error.hidden = true; update(); });
      checkout.addEventListener('click', async () => {
        if (busy) return;
        update();
        const items = cartItems(data, selections, select.value);
        if (!items) return;
        const selectionId = window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2);
        items.forEach(item => {
          item.properties._chhabra_selection = selectionId;
          item.properties._chhabra_return = window.location.pathname + (window.location.search || '') + '#' + section.id;
        });
        busy = true;
        error.hidden = true;
        update();
        const root = window.Shopify?.routes?.root || '/';
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cart?.setActiveElement) cart.setActiveElement(checkout);

        try {
          const response = await fetch(new Request(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          }));
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add your bundle. Please try again.');
          }

          if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'reference-bundle-builder', cartData: result });
          }

          let drawerRendered = false;
          if (cart && typeof cart.renderContents === 'function') {
            try {
              const secRes = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`);
              if (secRes.ok) {
                const sections = await secRes.json();
                if (sections && sections['cart-drawer']) {
                  cart.renderContents({ ...result, sections });
                  drawerRendered = true;
                }
              }
            } catch (_) {}
          }

          if (!drawerRendered) {
            if (cart && typeof cart.open === 'function') {
              cart.open();
            } else {
              window.location.assign(root + 'cart');
            }
          }
        } catch (err) {
          error.textContent = err.message;
          error.hidden = false;
        } finally {
          busy = false;
          update();
        }
      });
      instances.set(section, { update });
      update();
    });
  };
  window.chhabraReferenceBuilder = { initialize };
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
